import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { CascadeRendererFactory } from "src/shared/cascade-renderer-factory";
import { ISectionData, ISectionsAreaData } from "@pageBuilder/typings";
import { RendererBase } from "src/shared/renderer-base";
import { ElementUtil } from "src/utils/element-util";
import { IRenderingCommonContext } from "@commonRendering/types";

export abstract class SectionsAreaCascadeRendererBase<TData extends ISectionsAreaData> extends CascadeRendererBase<TData> {

    protected constructor(protected readonly renderer: RendererBase<TData>, renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
    }

    public override createByCascade(data: TData): HTMLElement {
        const element = this.renderer.createNew();
        this.renderer.render(element, data);

        const sectionArea = element.closest("[data-section-area]") as HTMLElement;

        data.sections?.forEach(sectionData => {
            const sectionRenderer = CascadeRendererFactory.create(sectionData.type, this.renderingCommonContext);
            const sectionElement = sectionRenderer.createByCascade(sectionData);
            sectionArea.append(sectionElement);
        });

        return element;
    }

    public override getDataByCascade(element: HTMLElement): TData | null {
        const data = this.renderer.getData(element);

        if (!data) {
            return null;
        }

        data.sections = [];

        element.querySelectorAll<HTMLElement>("[data-section]")?.forEach((sectionElement: HTMLElement) => {
            const sectionType = ElementUtil.resolveElementType(sectionElement);
            const sectionRenderer = CascadeRendererFactory.create(sectionType, this.renderingCommonContext);
            const sectionData = sectionRenderer.getDataByCascade(sectionElement) as ISectionData;
            data.sections?.push(sectionData);
        });

        return data;
    }

}
